import moment from 'moment';

const DATE_TIMESTAMP_FMT = 'DD/MM/YYYY HH:mm:ss';
const DATE_FMT = 'DD/MM/YYYY';
const DATE_PICKER_FMT = 'YYYY-MM-DD';
const DATE_MM_YYYY = 'MM/YYYY';

function outTimestampToISO(date: string): string {
  return moment(date, DATE_TIMESTAMP_FMT).toISOString();
}

function outDatepickerToISO(date: string): string {
  return moment(date, DATE_PICKER_FMT).toISOString();
}

function inISOToTimestamp(date: Date | string): string {
  return moment(date).format(DATE_TIMESTAMP_FMT);
}

function inISOToDatepicker(date: Date | string): string {
  return moment(date).format(DATE_PICKER_FMT);
}

function inTimestampToDatepicker(date: Date | string): string {
  return moment(date, DATE_TIMESTAMP_FMT).format(DATE_FMT);
}

function inDatepickerToTimestamp(date: string): string {
  return moment(date, DATE_PICKER_FMT).format(DATE_TIMESTAMP_FMT);
}

function dateToMonthAndYear(date: string): string {
  return moment(date).format(DATE_MM_YYYY);
}

export {
  outTimestampToISO,
  outDatepickerToISO,
  inISOToTimestamp,
  inDatepickerToTimestamp,
  inISOToDatepicker,
  inTimestampToDatepicker,
  dateToMonthAndYear,
};
